'use client';

import { cn } from '@/shared/lib/utils';
import {
	AlertDialog,
	AlertDialogAction,
	AlertDialogCancel,
	AlertDialogContent,
	AlertDialogDescription,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogOverlay,
	AlertDialogPortal,
	AlertDialogTitle,
} from '@/components/ui/alert-dialog';

import angkorLife from '@/assets/images/logo/angkorlife-logo.svg';
import { SwipeAlertDialog } from './SwipeAlertDialog';
import { useState } from 'react';

type Props = {
	open: boolean;
	onOpenChange: (open: boolean) => void;
	variant?: 'default' | 'error';
	logo?: boolean;
	title?: string;
	description?: string;
	cancelText?: string;
	actionText?: string;
	onCancel?: () => void;
	onConfirm?: () => void;
	hasSecondaryModal?: boolean;
};

export function CustomAlertDialog({
	open,
	onOpenChange,
	variant = 'default',
	logo = false,
	title,
	description,
	cancelText,
	actionText = 'Confirm',
	onCancel,
	onConfirm,
	hasSecondaryModal = false,
}: Props) {
	const [isSamsungModalOpen, setSamsungModalOpen] = useState(false);

	return (
		<>
			{/* 1. 메인 모달 */}
			<AlertDialog open={open} onOpenChange={onOpenChange}>
				<AlertDialogPortal>
					<AlertDialogOverlay className="fixed inset-0 bg-black/50 backdrop-blur-sm" />
					<AlertDialogContent
						className={cn(
							'fixed top-1/2 left-1/2 z-50 w-[280px] max-w-md -translate-x-1/2 -translate-y-1/2 rounded-lg bg-white p-4',
							'data-[state=open]:animate-in data-[state=closed]:animate-out'
						)}>
						<AlertDialogHeader
							className={`${variant === 'error' ? 'mb-4' : 'mb-6'}`}>
							{logo && (
								<div className="flex justify-center mb-3">
									<img src={angkorLife} alt="Logo" className="object-contain" />
								</div>
							)}
							{title && (
								<AlertDialogTitle
									className={`${
										variant === 'default' && 'mb-1 text-center'
									} text-start text-base font-medium leading-6`}>
									{title}
								</AlertDialogTitle>
							)}
							{description && (
								<AlertDialogDescription className="text-sm font-normal leading-5 text-center text-black">
									{description}
								</AlertDialogDescription>
							)}
						</AlertDialogHeader>

						<AlertDialogFooter
							className={`${cancelText && actionText && 'gap-2'} ${
								hasSecondaryModal && 'flex-col'
							} w-full flex justify-end`}>
							{cancelText && (
								<AlertDialogCancel
									className="w-1/2 text-sm border rounded-md hover:bg-gray-100"
									onClick={onCancel}>
									{cancelText}
								</AlertDialogCancel>
							)}
							{actionText && (
								<AlertDialogAction
									className={`${cancelText ? 'w-1/2' : 'w-full'}
								${variant === 'error' && 'w-fit  px-3 py-1.5'}
								bg-primary hover:bg-primary-dark text-sm text-black`}
									onClick={onConfirm}>
									{actionText}
								</AlertDialogAction>
							)}
							{hasSecondaryModal && (
								<button
									className="w-full text-sm font-medium leading-5 py-2.5"
									onClick={() => setSamsungModalOpen(true)}>
									Are you using a Samsung device?
								</button>
							)}
						</AlertDialogFooter>
					</AlertDialogContent>
				</AlertDialogPortal>
			</AlertDialog>

			{/* 2. 보조 모달 */}
			<SwipeAlertDialog
				open={isSamsungModalOpen}
				onOpenChange={setSamsungModalOpen}
				onCancel={() => setSamsungModalOpen(false)}
			/>
		</>
	);
}
